import { addDashIfNullOrUndefined } from "@domains/utils/numberMethods";
import React from "react";
import { Col, Row } from "react-bootstrap";
var EliteProgram = function (props) {
    return (React.createElement(React.Fragment, null,
        React.createElement(Row, { className: "mx-0 elite-heading-row px-0" },
            React.createElement(Col, { className: " DMSanBold_18_700 txt_blackOne1 px-0" }, "Elliance Program")),
        React.createElement(Row, { className: "mx-0 px-0" },
            React.createElement(Col, { className: "px-0" },
                React.createElement("div", { className: "DMSansMedium_12_500 txt_secondary-gray" }, "Elliance Partner"),
                React.createElement("div", { className: "mgt-5 DMSanM_14_500 txt_blackOne1" }, addDashIfNullOrUndefined(props.elliancepatner))),
            React.createElement(Col, { className: "px-0" },
                React.createElement("div", { className: "DMSansMedium_12_500 txt_secondary-gray" }, "Elliance Partner Acquired Program"),
                React.createElement("div", { className: "mgt-5 DMSanM_14_500 txt_blackOne1" }, addDashIfNullOrUndefined(props.acquiredprogram))),
            React.createElement(Col, { className: "px-0" },
                React.createElement("div", { className: "DMSansMedium_12_500 txt_secondary-gray" }, "Elliance Partner Code"),
                React.createElement("div", { className: "mgt-5 DMSanM_14_500 txt_blackOne1" }, addDashIfNullOrUndefined(props.patnercode))))));
};
export default EliteProgram;
